export default "__VITE_ASSET__BW7HT5PN__"